"use strict";
/**
 * Ported from https://github.com/googlemaps/android-maps-utils/blob/70cbb346e74eee8531a06d90521886eeef82efab/library/src/com/google/maps/android/SphericalUtil.java
 */
Object.defineProperty(exports, "__esModule", { value: true });
const MathUtil_1 = require("./MathUtil");
/**
 * Returns haversine(angle-in-radians).
 * hav(x) == (1 - cos(x)) / 2 == sin(x / 2)^2.
 */
function hav(x) {
    const sinHalf = Math.sin(x * 0.5);
    return sinHalf * sinHalf;
}
/**
 * Returns hav() of distance from (lat1, lng1) to (lat2, lng2) on the unit sphere.
 */
function havDistance(lat1, lat2, dLng) {
    return hav(lat1 - lat2) + hav(dLng) * Math.cos(lat1) * Math.cos(lat2);
}
/**
 * Returns distance on the unit sphere; the arguments are in radians.
 */
function distanceRadians(lat1, lng1, lat2, lng2) {
    return MathUtil_1.arcHav(havDistance(lat1, lat2, lng1 - lng2));
}
/**
 * Returns the angle between two LatLngs, in radians. This is the same as the distance
 * on the unit sphere.
 */
function computeAngleBetween(from, to) {
    return distanceRadians(MathUtil_1.toRadians(from.latitude), MathUtil_1.toRadians(from.longitude), MathUtil_1.toRadians(to.latitude), MathUtil_1.toRadians(to.longitude));
}
/**
 * Returns the distance between two LatLngs, in meters.
 */
function computeDistanceBetween(from, to) {
    return computeAngleBetween(from, to) * MathUtil_1.EARTH_RADIUS;
}
exports.computeDistanceBetween = computeDistanceBetween;
/**
 * Returns the length of the given path, in meters, on Earth.
 */
function computeLength(path) {
    if (path.length < 2) {
        return 0;
    }
    let length = 0;
    const prev = path[0];
    let prevLat = MathUtil_1.toRadians(prev.latitude);
    let prevLng = MathUtil_1.toRadians(prev.longitude);
    path.forEach(point => {
        const lat = MathUtil_1.toRadians(point.latitude);
        const lng = MathUtil_1.toRadians(point.longitude);
        length += distanceRadians(prevLat, prevLng, lat, lng);
        prevLat = lat;
        prevLng = lng;
    });
    return length * MathUtil_1.EARTH_RADIUS;
}
exports.computeLength = computeLength;
